<template>
  <div id="order">
    <!-- 左側內容 class必填-->
    <section class="main-box-left">
      <trade-info></trade-info>
    </section>
    <!-- 右側內容 class必填-->
    <section class="main-box-right">
      <checkout-action></checkout-action>
    </section>
  </div>
</template>
<script>
import { defineAsyncComponent, watch } from 'vue';
import { useGetters } from '@/utils/mapStore';
import { useRouter } from 'vue-router';
export default {
  name: 'checkout',
  components: {
    TradeInfo: defineAsyncComponent(() => import('@/components/checkout/left/TradeInfo.vue')),
    CheckoutAction: defineAsyncComponent(() => import('@/components/checkout/right/CheckoutAction.vue')),
  },
  setup() {
    const getTransaction = useGetters('checkout', ['getTransaction']);
    const router = useRouter();
    watch(
      getTransaction,
      () => {
        if (!Object.keys(getTransaction.value).length) router.push('/order');
      },
      { immediate: true }
    );
  },
};
</script>
<style lang="scss" scoped>
.main-box-right {
  //控制子元素比例，其餘css在main.scss
  grid-template-rows: auto 17.5% 6%;
  grid-gap: 8px;
}
</style>
